import { html } from '../lib/html.js';
import { icon } from '../lib/icons.js';
import { topbar } from '../components/chrome.js';

export default async function notfound() {
  return {
    title: 'Not found',
    html: html`${topbar({ back: '/' })}<div class="wrap"><div class="empty" style="margin-top:12vh">
      <span class="empty__icon">${icon('journey', { size: 26 })}</span>
      <h1 class="empty__title">This page is not in the book</h1>
      <p class="empty__text">The link may be mistyped, or the page may have moved.</p>
      <a class="btn btn--primary" href="/">Go to Today</a>
    </div></div>`,
  };
}
